import baseUrl from "../energyApiHost";
import { callApi } from "./util";

const getEnabledFeatures = () => {
  return callApi(`${baseUrl}configuration/features`);
};

export default {
  getEnabledFeatures
};
